import { useContext } from 'react';

import useModalManager from './useModalManager';

/**
 * @example const { ... } = useModalContext();
 * @returns ...
 */
const useModalContext = () => {
  const { ModalContext } = useModalManager();
  return useContext(ModalContext);
};

export default useModalContext;
